import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router';
import JobDescriptionGenerator from './HomePage';
import JobDescLogin from './Auth/JobDescLogin';
import JobDescPrivateRoute from './Auth/JobDescPrivateRoute';
import JobDescriptionLandingPage from './JobDescriptionLandingPage';
import Pagenotfound from '../../components/views/PageNotFound';
export default function JobDescriptionRoute() {
  return (
    <div>
    {/* <BrowserRouter> */}
      <Routes>
      <Route path="/jobdescription">
              <Route path="*" element={<Pagenotfound />} />
              <Route path='jobdescriptionUtility' element={<JobDescriptionLandingPage/>} /> 
              <Route path="login" element={<JobDescLogin />} />
              <Route
                path="generate"
                element={
                  <JobDescPrivateRoute>
                    <JobDescriptionGenerator/>
                  </JobDescPrivateRoute>
                }
              />
            </Route>
      </Routes>
    {/* </BrowserRouter> */}
    </div>
  )
}
